import {
  useSetLocale,
  useUserSettingsStore,
} from '@app/core/user-settings/stores/user-settings.store';
import { formatUserLocale } from '@app/locale/helper';
import debugFn from 'debug';
import { useEffect } from 'react';
import { useAuth } from '../../authentication/hooks/useAuth';

const debug = debugFn('useUserLocaleCheck');

export function useUserLocaleCheck() {
  const { user, client } = useAuth();
  const setLocale = useSetLocale();
  const storedLocale = useUserSettingsStore((s) => s.locale);
  const userLocale = formatUserLocale(user.language ?? client?.language ?? '');

  useEffect(() => {
    if (storedLocale === userLocale) {
      debug('Locale is already set (%s)', userLocale);
      return;
    }

    debug('Setting locale from %s (stored) to %s (user)', storedLocale, userLocale);
    setLocale(userLocale);
  }, [storedLocale, userLocale]);
}
